import { PropertyBase } from './property-base.model';

export class TextProperty extends PropertyBase {
  constructor(data: any = {}) {
    super();
    this.title = data.title == 'Label' ? '' : data.title || 'Header';
    this.value = data.value || '';
    this.placeholder = data.placeholder || '';
  }
}
